import React from 'react';
import AttachmentViewWithPreviewInEditor from "../../../../files/attachment-view/in-editor/with-preview";
import AttachmentViewNoPreviewInEditor from "../../../../files/attachment-view/in-editor/no-preview";

// const debug = "AttachmentInRichEditor"
const debug = false

export default class AttachmentInRichEditor extends React.Component {

    constructor(props) {
        super(props);
        debug && console.log(debug, "Constructor", this.props)
    }

    renderAspectRatio = () => {
        const { aspectRatio } = this.props.contentState.getEntity(this.props.block.getEntityAt(0)).getData();

        const styles = {};
        if (aspectRatio) styles.paddingTop = (aspectRatio * 100) + "%";

        return <div className="aspect-ratio-component" style={styles}/>
    }

    render() {

        debug && console.log(debug, "render() !!!", this.props)

        // omit certain properties from props
        const elementProps = _.omit(this.props, ['preventScroll', 'block', 'className', 'theme', 'blockProps',
            'customStyleMap', 'customStyleFn', 'decorator', 'forceSelection', 'offsetKey', 'selection', 'tree',
            'contentState', 'blockStyleFn', 'isReadOnly', 'onRemove']);

        const combinedClassName = Classes("attachment-plugin-component", this.props.className);


        const data = this.props.contentState.getEntity(this.props.block.getEntityAt(0)).getData();

        // now init attachment - we try to do it via attachments collections
        // if not possible fallback with build in data... but in future we need only
        // attachmentsCollection + fileId + ration
        let attachment;

        if (!this.props.blockProps.attachmentsCollection) {
            console.error("#jdu87 - no attachmentCollestion provided to attachmentPlugin in rich editor")
        }

        if (this.props.blockProps.attachmentsCollection && this.props.blockProps.attachmentsCollection.get(data.fileId)) {
            attachment = this.props.blockProps.attachmentsCollection.get(data.fileId)
            // console.blue("URA ... initialized from collection !!! now we can do anything we want :)")
        } else {
            console.error("SOMETHING is wrong - no attachment found by id")
            return false;
            // attachment = new Attachment(data)
        }

        // console.warn('DATA has aspectRation ... what to do about it ?')
        // data.aspectRation
        // data.editorPreview: true

        const AttachmentViewComponent = attachment.previewAvailable ? AttachmentViewWithPreviewInEditor : AttachmentViewNoPreviewInEditor

        return (
            <div className={combinedClassName} draggable="true" {...elementProps}>

                <AttachmentViewComponent className="attachment-container"
                                mode={this.props.isReadOnly ? "view-in-editor" : "edit-in-editor"}
                                attachment={attachment}
                                onRemove = {this.props.onRemove} />

                {this.renderAspectRatio()}
                {this.props.children}
            </div>
        );
    }
}